import { render, staticRenderFns } from "./delivery.vue?vue&type=template&id=c76b9e68&scoped=true"
import script from "./delivery.vue?vue&type=script&lang=js"
export * from "./delivery.vue?vue&type=script&lang=js"
import style0 from "./delivery.vue?vue&type=style&index=0&id=c76b9e68&prod&lang=scss&scoped=true"
import style1 from "./delivery.vue?vue&type=style&index=1&id=c76b9e68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c76b9e68",
  null
  
)

export default component.exports